__turbopack_context__.v({
  "fieldsStack": "aWzRcG_fieldsStack",
  "form": "aWzRcG_form",
  "formHidden": "aWzRcG_formHidden",
  "loaderContainer": "aWzRcG_loaderContainer",
  "savingMessage": "aWzRcG_savingMessage",
  "section": "aWzRcG_section",
  "stickyBanner": "aWzRcG_stickyBanner",
});
